import resumeBtn from "@assets/imgs/btns/resume-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export class ResumeBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;

  static preload(scene: Phaser.Scene) {
    scene.load.image("resume-btn", resumeBtn);
  }

  constructor(scene: Phaser.Scene, x: number, y: number, onClick: () => void) {
    super(scene, x, y, {
      onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });

    this.bg = scene.add.image(0, 0, "resume-btn").setOrigin(0.5);

    this.add(this.bg);

    this.enableButton(this.bg.width, this.bg.height);

    scene.add.existing(this);
  }

  private setPressedStyle() {
    this.setScale(0.9);
  }

  private resetButton() {
    this.setScale(1);
  }
}
